import React, { useEffect, useState } from 'react';
import { Card, Space, Row, Col, Spin, Modal, Select, Input } from 'antd';
import { DeleteOutlined, PlusOutlined, CloudUploadOutlined, SaveOutlined } from '@ant-design/icons';
import ScreenEditor from './components/FormBuilder/ScreenEditor';
import { useAuth } from '../../context/auth.context';
import './style.css';
import { BasicFormWrapper, Main } from '../styled';
import { Form } from 'antd';
import {} from 'react-router-dom';
import { Button } from '../../components/buttons/buttons';
import { useNotification } from '../../context/notification.context';
import { formatFormToWhatsappFlow } from './functions';
import useApiFetch from '../../hooks/useApiFetch';
import { useHistory } from 'react-router-dom';
import { PageHeader } from '../../components/page-headers/page-headers';
import { WaFormsPage } from './wa-forms-style';

const EditWaForm = ({ match }) => {
    const { notifyError, notifySuccess, notifyWarning } = useNotification();
    const { apiClient } = useAuth();
    const [form] = Form.useForm();
    const [screens, setScreens] = useState([]);
    const [saving, setSaving] = useState(false);
    const [publishing, setPublishing] = useState(false);
    const [openPublishModal, setOpenPublishModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    const [formMeta, setFormMeta] = useState();
    const [currentScreenId, setCurrentScreenId] = useState(null);
    const history = useHistory();
    // const navigate = useNavi
    const flowUuid = match.params.uuid;
    const addNewScreen = () => {
        const newScreen = {
            id: `screen-${screens.length + 1}`,
            title: `Screen ${screens.length + 1}`,
            components: [],
            footerButton: {
                label: 'Continue',
            },
        };
        setCurrentScreenId(newScreen.id);
        setScreens([...screens, newScreen]);
    };
    const { data, refetch, axiosError, loading } = useApiFetch(`/api/integrations/whatsapp/wa-flows?uuid=${flowUuid}`);

    useEffect(() => {
        if (!loading && data) {
            const flow = data?.data?.[0];
            if (!flow) {
                notifyWarning({
                    message: 'Form not found',
                });
                return;
            }
            const { name, categories, description, flowJson } = flow;
            setFormMeta({ name, category: categories[0], description, status: flow.status });
            if (flowJson?.screens?.length) {
                setCurrentScreenId(flowJson?.screens[0].id);
            }
            setScreens(
                flowJson?.screens?.map((screen, screenIndex) => {
                    const components = screen?.layout?.children?.[0]?.children || [];
                    const footerButton = components.find((comp) => comp.type === 'Footer');
                    const componentsWithIds = components.map((comp, index) => {
                        return {
                            ...comp,
                            id: `${comp.type}_${screenIndex}_${index}`,
                        };
                    });
                    return {
                        ...screen,
                        components: componentsWithIds,
                        layout: undefined,
                        footerButton,
                        // footerButton
                    };
                }) || [],
            );
            setPreviewUrl(flow.previewUrl);
        }
    }, [data, loading]);

    const getCurrentScreen = () => {
        return screens.find((screen) => screen.id === currentScreenId);
    };

    const handleScreenSelect = (screenId) => {
        setCurrentScreenId(screenId);
    };

    const handleSubmit = async () => {
        await form.validateFields();
        setSaving(true);
        try {
            const res = await apiClient.put(`/api/integrations/whatsapp/wa-flows/${flowUuid}`, {
                name: formMeta.name,
                category: formMeta.category,
                description: formMeta.description || '',
                flowJson: formatFormToWhatsappFlow(screens),
            });
            const updatedFlow = res.data?.data[0];
            if (updatedFlow) {
                setPreviewUrl(updatedFlow.previewUrl);
            }
            notifySuccess({
                message: res?.data?.message || 'Form updated successfully',
            });
        } catch (error) {
            console.error(error);
            notifyError({
                message: error.response?.data?.message || 'Error updating form',
            });
        } finally {
            setSaving(false);
        }
    };

    const publishFlow = async () => {
        setPublishing(true);
        try {
            const res = await apiClient.post(`/api/integrations/whatsapp/wa-flows/${flowUuid}/publish`);
            notifySuccess({
                message: res?.data?.message || 'Form published successfully',
            });
            history.push('/admin/wa-forms');
        } catch (error) {
            notifyError({
                message: error.response?.data?.message || 'Error publishing form',
            });
        } finally {
            setPublishing(false);
        }
    };
    return (
        <WaFormsPage>
            <PageHeader
                buttons={
                    [
                        // <Button className="btn-add_new" size="small" key="1" type="primary" outlined>
                        //   <FeatherIcon icon='back'/>
                        //   <Link key="1" to="/admin/solutions">
                        //     View All
                        //   </Link>
                        // </Button>,
                    ]
                }
                routes={[
                    {
                        path: '/admin/overview',
                        icon: 'home',
                    },
                    {
                        breadcrumbName: 'Bot',
                    },
                    {
                        breadcrumbName: 'Whatsapp Forms',
                        path: '/admin/wa-forms',
                    },
                    {
                        breadcrumbName: 'Edit WhatsApp Form',
                        path: window.location.pathname,
                    },
                ]}
                title={
                    <Space>
                        <span>Update WhatsApp Form</span>
                        {formMeta && (
                            <>
                                {formMeta.status === 'DRAFT' && <span className="status info">DRAFT</span>}
                                {formMeta.status === 'BLOCKED' && <span className="status warning">BLOCKED</span>}
                                {formMeta.status === 'PUBLISHED' && <span className="status success">PUBLISHED</span>}
                            </>
                        )}
                    </Space>
                }
            />
            <Main className="waforms-main">
                <BasicFormWrapper>
                    <Spin spinning={loading}>
                        {!loading && formMeta && (
                            <Form initialValues={formMeta} onFinish={handleSubmit} form={form}>
                                <Row>
                                    <Col span={12}>
                                        <Space
                                            direction="vertical"
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            <Card>
                                                <Space direction="vertical" style={{ width: '100%' }} size="large">
                                                    <Space direction="vertical" style={{ width: '100%' }}>
                                                        <Form.Item
                                                            label="Form Name"
                                                            name="name"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please enter form name',
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                type="text"
                                                                className="ant-input"
                                                                placeholder="Form Name"
                                                                value={formMeta.name}
                                                                onChange={(e) =>
                                                                    setFormMeta({ ...formMeta, name: e.target.value })
                                                                }
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Category"
                                                            name="category"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please select category',
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder="Select a category"
                                                                value={formMeta.category}
                                                                onChange={(value) =>
                                                                    setFormMeta({ ...formMeta, category: value })
                                                                }
                                                            >
                                                                <Select.Option value="SIGN_UP">Sign Up</Select.Option>
                                                                <Select.Option value="SIGN_IN">Sign In</Select.Option>
                                                                <Select.Option value="APPOINTMENT_BOOKING">
                                                                    Appointment Booking
                                                                </Select.Option>
                                                                <Select.Option value="LEAD_GENERATION">
                                                                    Lead Generation
                                                                </Select.Option>
                                                                <Select.Option value="CONTACT_US">
                                                                    Contact Us
                                                                </Select.Option>
                                                                <Select.Option value="CUSTOMER_SUPPORT">
                                                                    Customer Support
                                                                </Select.Option>
                                                                <Select.Option value="SURVEY">Survey</Select.Option>
                                                                <Select.Option value="OTHER">Other</Select.Option>
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item label="Description (Optional)" name="description">
                                                            <Input.TextArea
                                                                value={formMeta.description}
                                                                onChange={(e) =>
                                                                    setFormMeta({
                                                                        ...formMeta,
                                                                        description: e.target.value,
                                                                    })
                                                                }
                                                                placeholder="Description"
                                                                autoSize={{ minRows: 3, maxRows: 5 }}
                                                            />
                                                        </Form.Item>
                                                    </Space>
                                                </Space>
                                            </Card>
                                            <br />
                                            <br />
                                            <Card>
                                                <Space direction="vertical" style={{ width: '100%' }} size="large">
                                                    {/* Screen List */}
                                                    <div className="screens-list">
                                                        {screens.map((screen) => (
                                                            <div
                                                                key={screen.id}
                                                                className={`screen-item ${
                                                                    screen.id === currentScreenId ? 'active' : ''
                                                                }`}
                                                                onClick={() => handleScreenSelect(screen.id)}
                                                            >
                                                                <div className="screen-title">
                                                                    {screen.title}
                                                                    {screens.length > 1 && (
                                                                        <Button
                                                                            size="small"
                                                                            // outlined
                                                                            transparented
                                                                            type={'danger'}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setCurrentScreenId(
                                                                                    currentScreenId === screen.id
                                                                                        ? null
                                                                                        : currentScreenId,
                                                                                );
                                                                                setScreens(
                                                                                    screens.filter(
                                                                                        (s) => s.id !== screen.id,
                                                                                    ),
                                                                                );
                                                                            }}
                                                                            icon={<DeleteOutlined />}
                                                                        ></Button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <Button
                                                            style={{
                                                                width: 'fit-content',
                                                            }}
                                                            type="dashed"
                                                            icon={<PlusOutlined />}
                                                            onClick={addNewScreen}
                                                            // color='red'
                                                        >
                                                            Add new
                                                        </Button>
                                                    </div>

                                                    {/* Screen Editor */}
                                                    {currentScreenId && (
                                                        <ScreenEditor
                                                            screen={getCurrentScreen()}
                                                            onScreenUpdate={(updatedScreen) => {
                                                                const updatedScreens = screens.map((s) =>
                                                                    s.id === updatedScreen.id ? updatedScreen : s,
                                                                );
                                                                setScreens(updatedScreens);
                                                                // console.log(
                                                                //     'updated screens',
                                                                //     updatedScreens
                                                                // );
                                                            }}
                                                        />
                                                    )}
                                                </Space>
                                            </Card>
                                        </Space>
                                    </Col>
                                    <Col span={12}>
                                        {saving ? (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    height: '90vh',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Spin spinning={saving} tip="Loading preview..."></Spin>
                                            </div>
                                        ) : (
                                            <iframe
                                                src={previewUrl}
                                                style={{
                                                    width: '100%',
                                                    height: '90vh',
                                                    border: 'none',
                                                }}
                                                title="Preview"
                                            />
                                        )}
                                    </Col>
                                </Row>
                                <br />
                                <div className="sDash_form-action">
                                    <Button onClick={() => history.goBack()} type="light">
                                        Cancel
                                    </Button>
                                    <Button
                                        disabled={formMeta.status === 'PUBLISHED'}
                                        loading={saving}
                                        htmlType="submit"
                                        type="primary"
                                        size={'default'}
                                        icon={<SaveOutlined />}
                                        title={formMeta.status === 'PUBLISHED' ? 'Form is published' : ''}
                                    >
                                        {saving ? 'Saving...' : 'Save As Draft & Preview'}
                                    </Button>

                                    <Button
                                        disabled={formMeta.status === 'PUBLISHED'}
                                        type="primary"
                                        size={'default'}
                                        icon={<CloudUploadOutlined />}
                                        onClick={() => setOpenPublishModal(true)}
                                    >
                                        Publish
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Spin>
                </BasicFormWrapper>
            </Main>
            <Modal
                title="Publish Form"
                open={openPublishModal}
                onOk={publishFlow}
                onCancel={() => setOpenPublishModal(false)}
                okText="Publish"
                confirmLoading={publishing}
            >
                <p>Are you sure you want to publish this form?</p>
            </Modal>
        </WaFormsPage>
    );
};

export default EditWaForm;
